import { getFeedKey, getPinnedPostsKey, getPostsKey } from '../../utils/keys';
// get all active/inactive posts queries
export const postsQueryFilter = {
    predicate: query => {
        var _a;
        const { state, queryKey } = query;
        const [main] = queryKey || [];
        if ((main === getFeedKey()[0] || main === getPostsKey()[0]) &&
            Array.isArray((_a = state === null || state === void 0 ? void 0 : state.data) === null || _a === void 0 ? void 0 : _a.pages) // checking if the disabled(inactive) query actually has data to update or not
        ) {
            return true;
        }
        return false;
    },
};
export const pinnedPostsFilter = {
    predicate: query => {
        var _a;
        const queryMainKey = (_a = query === null || query === void 0 ? void 0 : query.queryKey) === null || _a === void 0 ? void 0 : _a[0];
        if (queryMainKey === getPinnedPostsKey()[0]) {
            return true;
        }
        return false;
    },
};
// to get one replies/posts query with a specific id
export const getPostsQueryById = postId => ({
    predicate: query => {
        var _a, _b, _c;
        const { state, queryKey } = query;
        const [main, args] = queryKey || [];
        if (main === getPostsKey()[0] &&
            ((_b = (_a = args) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.postId) === postId &&
            Array.isArray((_c = state === null || state === void 0 ? void 0 : state.data) === null || _c === void 0 ? void 0 : _c.pages) // checking if the disabled(inactive) query actually has data to update or not
        ) {
            return true;
        }
        return false;
    },
});
//# sourceMappingURL=filters.js.map